import { render, staticRenderFns } from "./TeamPositionsSlide.vue?vue&type=template&id=79854fcd"
import script from "./TeamPositionsSlide.vue?vue&type=script&lang=js"
export * from "./TeamPositionsSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79854fcd')) {
      api.createRecord('79854fcd', component.options)
    } else {
      api.reload('79854fcd', component.options)
    }
    module.hot.accept("./TeamPositionsSlide.vue?vue&type=template&id=79854fcd", function () {
      api.rerender('79854fcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/TeamPositionsSlide.vue"
export default component.exports